import { Box } from "@mui/material";
import React, { useState } from "react";
import { DeliveryCard } from "../../Checkout";
import { useLocationContext } from "../../../context/Location";

function AddressCard() {
  const [selectedAddress, setSelectedAddress] = useState();
  const { setLocation } = useLocationContext();

  const setDeliveryAddress = (item) => {
    setSelectedAddress(item);
    setLocation({
      _id: item?._id,
      label: item?.label,
      latitude: Number(item?.location.coordinates[1]),
      longitude: Number(item?.location.coordinates[0]),
      deliveryAddress: item?.deliveryAddress,
      details: item?.details,
      apartment: item?.apartment,
      buildingName: item?.buildingName,
      entryCode: item?.entryCode,
      dropoffOption: item?.dropoffOption,
      instructions: item?.instructions,
    });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <DeliveryCard
        selectedAddress={selectedAddress}
        setSelectedAddress={setDeliveryAddress}
        isProfile={true}
      />
    </Box>
  );
}

export default React.memo(AddressCard);
